import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardAPI as API } from '../../../axiosConfig';

const URL = 'proxy?endpoint=supernova/rule/source-channel-hash';

const SLICE_NAME = 'ruleSource';
const GET_ORCHESTRATION_RULE_SOURCE_LIST = `${SLICE_NAME}/get`;
const GET_ORCHESTRATION_RULE_SOURCE = `${SLICE_NAME}/{id}`;
const ADD_ORCHESTRATION_RULE_SOURCE = `${SLICE_NAME}/add`;
const UPDATE_ORCHESTRATION_RULE_SOURCE = `${SLICE_NAME}/{id}/update`;
const DELETE_ORCHESTRATION_RULE_SOURCE = `${SLICE_NAME}/{id}/delete`;

export const getRuleSources = createAsyncThunk(
  GET_ORCHESTRATION_RULE_SOURCE_LIST,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.get(URL);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getRuleSourceById = createAsyncThunk(
  GET_ORCHESTRATION_RULE_SOURCE,
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await API.get(`${URL}/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const addRuleSource = createAsyncThunk(
  ADD_ORCHESTRATION_RULE_SOURCE,
  async ({ payload, headers }, { rejectWithValue }) => {
    try {
      const { data } = await API.post(URL, payload, {
        headers,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const updateRuleSource = createAsyncThunk(
  UPDATE_ORCHESTRATION_RULE_SOURCE,
  async ({ payload, id, headers }, { rejectWithValue }) => {
    try {
      const { data } = await API.put(`${URL}/${id}`, payload, {
        headers,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const deleteRuleSource = createAsyncThunk(
  DELETE_ORCHESTRATION_RULE_SOURCE,
  async ({ id, user, headers }, { rejectWithValue }) => {
    try {
      const { data } = await API.delete(`${URL}/${id}?user=${user}`, {
        headers,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const invalidateCache = createAsyncThunk(
  'ruleSource/refreshCache',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.get(`${URL}/invalidatecache`);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const sourceSlice = createSlice({
  name: SLICE_NAME,
  initialState: {
    list: [],
  },
  reducers: {},
  extraReducers: {
    [getRuleSources.fulfilled]: (state, action) => {
      if (action.payload.status !== 'SUCCESS') {
        state.list = [];
        return;
      }

      if (!action.payload || !action.payload.data) {
        return;
      }

      state.list = [...action.payload.data];
    },
    [addRuleSource.fulfilled]: (state, action) => {
      if (action.payload.status !== 'SUCCESS') {
        return;
      }

      const { data } = action.payload;

      state.list = [...state.list, data[0]];
    },
    [updateRuleSource.fulfilled]: (state, { payload }) => {
      if (payload.status !== 'SUCCESS') {
        return;
      }
      const updatedList = [...state.list];
      const updatedData = payload.data[0];
      const updateIndex = updatedList.findIndex(
        (source) => source.id === updatedData.id,
      );
      if (updateIndex !== -1) {
        updatedList[updateIndex] = { ...updatedData };
        state.list = [...updatedList];
      }
    },
    [deleteRuleSource.fulfilled]: (state, action) => {
      if (action.payload.status !== 'SUCCESS') {
        return;
      }

      const data = [...state.list];
      const deletedId = action.payload.id;
      const deletedIndex = data.findIndex((source) => source.id === deletedId);
      data.splice(deletedIndex, 1);
      state.list = [...data];
    },
  },
});

export const sourceActions = sourceSlice.actions;

export const selectRuleSources = (state) =>
  state.paymentOrchestration.sources.list;

export default sourceSlice.reducer;
